/**
 * purgeUserScopedCaches — data-isolation sweep (2026 audit)
 * =========================================================
 * Removes every browser-storage entry that holds USER-SPECIFIC data.
 * Called on logout, add-account and account-switch so the next user
 * on the same device never sees the previous user's cached payloads.
 *
 * Device-level preferences (language, theme, sidebar state, whiteboard
 * tool prefs) are intentionally NOT touched.
 */
const SESSION_KEYS = [
  'dashboard-stats-cache',
  'dashboard-mysub-cache',
  'teacher-kpi-cache',
  'mesp_session_hint',
];
const SESSION_PREFIXES = ['chat-msgs:'];
const LOCAL_KEYS = ['mesp.recent_items', 'mesp_session_hint'];

export function purgeUserScopedCaches() {
  try {
    SESSION_KEYS.forEach((k) => sessionStorage.removeItem(k));
    for (let i = sessionStorage.length - 1; i >= 0; i -= 1) {
      const key = sessionStorage.key(i);
      if (key && SESSION_PREFIXES.some((p) => key.startsWith(p))) {
        sessionStorage.removeItem(key);
      }
    }
  } catch (_e) { /* private mode — ignore */ }
  try {
    LOCAL_KEYS.forEach((k) => localStorage.removeItem(k));
  } catch (_e) { /* ignore */ }
}

export default purgeUserScopedCaches;

/**
 * hardWipeBrowserState — Force Logout (Sep 2026 auth-loop fix)
 * ============================================================
 * Nukes ALL localStorage + sessionStorage + JS-visible cookies so no
 * stale auth signal can resurrect a session or auto-redirect to the
 * dashboard. Device-level language preference is preserved.
 */
export function hardWipeBrowserState() {
  let lang = null;
  try { lang = localStorage.getItem('mesp_language'); } catch (_e) { /* ignore */ }
  try { localStorage.clear(); } catch (_e) { /* ignore */ }
  try { sessionStorage.clear(); } catch (_e) { /* ignore */ }
  try {
    document.cookie.split(';').forEach((c) => {
      const name = c.split('=')[0].trim();
      if (!name) return;
      document.cookie = `${name}=; Max-Age=0; path=/`;
      document.cookie = `${name}=; Max-Age=0; path=/; domain=${window.location.hostname}`;
    });
  } catch (_e) { /* ignore */ }
  try { if (lang) localStorage.setItem('mesp_language', lang); } catch (_e) { /* ignore */ }
}
